<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="failureofjustice-kindleinterior-5-8-2016"></div>
<div class="calibre1" id="tc-101">
<div class="calibre1"></div>
<div class="calibre1">
<p class="chapter-sub"><span class="no-style-override2">Other Exciting WildBlue Press Books by Jon Ferak</span></p>
<p class="normal"><span class="no-style-override1"><br class="calibre1"/></span></p>
<p class="normal"><span class="no-style-override1"><br class="calibre1"/></span></p>
<p class="normal"><span class="no-style-override1"><br class="calibre1"/></span></p>
<p class="normal-242-0-override2"><span class="no-style-override1">DIXIE’S LAST STAND:</span> <span class="no-style-override">Was It Murder Or Self-Defense?</span></p>
<p class="normal-242-0-override2"><span class="no-style-override3"><a href="http://wbp.bz/dixie" target="_blank">http://wbp.bz/dixie</a></span><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-242-0-override2"><span class="no-style-override1"><br class="calibre1"/></span></p>
<p class="normal-242-0-override2"><span class="no-style-override1">BODY OF PROOF:</span> <span class="no-style-override">Tainted Evidence In The Murder Of Jessica O’Grady</span></p>
<p class="normal-242-0-override2"><span class="no-style-override3"><a href="http://wbp.bz/bop" target="_blank">http://wbp.bz/bop</a></span><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="calibre2" id="calibre_pb_4"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?4dae9ba6